import {
  Form,
  Input,
  Button,
  Upload,
  notification,
  Row,
  Col,
  Divider,
  Typography,
  Tag,
  Tooltip,
  Image,
  Card,
  Modal,
  Select,
  Space,
  message,
  DatePicker,
  Switch,
} from "antd";
import {
  WarningFilled,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  QuestionCircleOutlined,
  DownloadOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import dayjs from "dayjs";

import "./styles.css";
import { Context } from "../../context";
import { Delete, Fetch, Put } from "../../fetch";
import UploadVideo from "../UploadContent/videos";
import UploadSubtitles from "../UploadContent/subtitles";
import {
  validateNumberField,
  validateYoutubeInput,
  validateApplePodcastInput,
  validateSpotifyInput,
} from "../../validators";
import HtmlDisplay from "./EmbedCopy";
import DirectUpload from "../UploadContent/directupload";

const { TextArea } = Input;
const { confirm } = Modal;
const { Option } = Select;

const Episode = ({
  seriesId,
  episode_number,
  season,
  Hindi,
  Telugu,
  Tamil,
  refreshControl,
  updatePanel,
  episode_id,
}) => {
  const { token, apiUrl } = useContext(Context);
  const { Text, Title } = Typography;
  const [streamType, setStreamType] = useState("default");
  const [releaseDate, setReleaseDate] = useState();
  const [subtitlesUploaded, setSubtitlesUploaded] = useState(false);
  const [detailImageUrl, setDetailImageUrl] = useState(null);
  const [detailImageLoading, setDetailImageLoading] = useState(false);
  const [cardImageLoading, setCardImageLoading] = useState(false);
  const [trailerImageLoading, setTrailerImageLoading] = useState(false);
  const [logoImageLoading, setLogoImageLoading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(false);
  const [cardImageUrl, setCardImageUrl] = useState();
  const [trailerImageUrl, setTrailerImageUrl] = useState();
  const [logoImageUrl, setLogoImageUrl] = useState();
  const [data, setData] = useState(null);
  const [genres, setGenres] = useState([]);
  const [hosts, setHosts] = useState([]);
  const [guests, setGuests] = useState([]);
  const [tech, setTech] = useState([]);
  const [creators, setCreators] = useState([]);
  const [checked, setChecked] = useState(false);

  const handleDetailImageUploadStatusChange = (info) => {
    console.log(info);
    if (info.file.status === "uploading") {
      setDetailImageLoading(true);
      return;
    }

    if (info.file.status === "done") {
      setDetailImageLoading(false);
      const url = info.file.response.url + "/detailImage";
      setDetailImageUrl(url);
      episodesForm.setFieldValue("detailImage", url);
    }
  };

  const [upload, setUpload] = useState({
    id: null,
    season: null,
    episode: null,
    type: "",
  });

  const [episodesForm] = Form.useForm();

  useEffect(() => {
    episodesForm.resetFields();
    Fetch(`${apiUrl}/episodes?id=${episode_number}`, token, (result) => {
      if (result.success === true) {
        let episode = result.data;
        if (episode.releaseDate) {
          setReleaseDate(dayjs(episode.releaseDate));
          episodesForm.setFieldValue("releaseDate", dayjs(episode.releaseDate));
        }
        if ("detailImage" in episode) {
          setDetailImageUrl(episode["detailImage"]);
        }
        if ("cardImage" in episode) {
          setCardImageUrl(episode["cardImage"]);
        }
        if ("trailerImage" in episode) {
          setTrailerImageUrl(episode["trailerImage"]);
        }
        if ("logoImage" in episode) {
          setLogoImageUrl(episode["logoImage"]);
        }
        if (episode.enable_subs) {
          setChecked(episode.enable_subs);
        }
        Fetch(
          `${apiUrl}/seasons/${episode.series}/${episode.season}`,
          token,
          (result) => {
            if (result.success === true) {
              result = result.season;
              let genres = result.genre;
              Fetch(`${apiUrl}/genres`, token, (result) => {
                let g = result.genres;
                g = g.filter((v) => genres.includes(v._id));
                setGenres(g);
              });
              let hosts = result.hosts;
              let guests = result.guests;
              let tech = result.tech;
              Fetch(`${apiUrl}/crew`, token, (result) => {
                if (result) {
                  let h = result.hosts;
                  let g = result.guests;
                  let t = result.tech;
                  if (hosts) {
                    h = h.filter((v) => hosts.includes(v._id));
                  } else {
                    h = null;
                  }
                  if (guests) {
                    g = g.filter((v) => guests.includes(v._id));
                  } else {
                    g = null;
                  }
                  if (tech) {
                    t = t.filter((v) => tech.includes(v._id));
                  } else {
                    t = null;
                  }
                  setHosts(h);
                  setGuests(g);
                  setTech(t);
                  setCreators(result.creators);
                }
              });
              episodesForm.setFieldsValue(episode);
            }
          }
        );
        setData(episode);
      }
    });
    console.log("current episode data - ", data);
  }, [apiUrl, token, season]);

  const validateInputFields = (_, value) => {
    console.log("input validation - ", value);
    if (!value) {
      return Promise.reject(new Error("Missing mandatory field"));
    }
    if (/^\s/.test(value)) {
      return Promise.reject(new Error("Input cannot start with a space"));
    }
    if (value.length < 3 || value.length > 255) {
      return Promise.reject(
        new Error("Input must be between 3-255 characters")
      );
    }
    return Promise.resolve();
  };
  const validateDescriptionFields = (_, value) => {
    console.log("input validation - ", value);
    if (!value) {
      return Promise.reject(new Error("Missing mandatory field"));
    }
    if (/^\s/.test(value)) {
      return Promise.reject(new Error("Input cannot start with a space"));
    }
    if (value && value.length < 2) {
      return Promise.reject(
        new Error("Input must contain atleast 2 characters")
      );
    }
    return Promise.resolve();
  };

  const handleEpisodeSave = async () => {
    let values;
    try {
      values = await episodesForm.validateFields();
      values = { ...values, enable_subs: checked };
    } catch (err) {
      notification.error({
        message: "Error Updating Episode",
        description: "Required/Optional fields are incorrect/missing",
      });
      return;
    }
    if (values.skipIntroStart && values.skipIntroEnd) {
      if (values.skipIntroStart >= values.skipIntroEnd) {
        notification.error({
          message: "Error updating episode",
          description: "Skip Intro End must be greater than Skip Intro Start",
        });
        return;
      }
    }
    if (releaseDate) {
      values = { ...values, releaseDate: releaseDate.format("YYYY-MM-DD") };
    }
    values = { ...values, old: data };
    Put(
      `${apiUrl}/episodes/${episode_number}`,
      token,
      {
        ...values,
        season: season,
      },
      (result) => {
        if (result.success === true) {
          notification.success({
            message: "Success",
            description: "Episode Saved",
          });
          refreshControl[1](() => true);
          updatePanel[1](() => null);
        } else {
          notification.error({
            message: "Error Updating Episode",
            description: result["message"],
          });
        }
      }
    );
  };

  const handleEpisodeDelete = async () => {
    Delete(`${apiUrl}/episodes/${episode_number}`, token, (result) => {
      if (result.success) {
        notification.success({
          message: "Success",
          description: "Episode Deleted",
        });
        refreshControl[1](() => true);
        updatePanel[1](() => null);
      } else {
        notification.error({
          message: "Error deleting Episode",
          description: "Check console for more info",
        });
        refreshControl[1](() => true);
        updatePanel[1](() => null);
      }
    });
  };

  const beforeImageUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("Only JPG and PNG files are allowed");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must be smaller than 2M");
    }

    return isJpgOrPng && isLt2M;
  };

  const handleCardImageUploadStatusChange = (info) => {
    if (info.file.status === "uploading") {
      setCardImageLoading(true);
      return;
    }

    if (info.file.status === "done") {
      setCardImageLoading(false);
      const url = info.file.response.url + "/cardImage";
      setCardImageUrl(url);
      episodesForm.setFieldsValue({ cardImage: url });
      setUploadStatus(false);
    }
  };

  const handleTrailerImageUploadStatusChange = (info) => {
    if (info.file.status === "uploading") {
      setTrailerImageLoading(true);
      return;
    }

    if (info.file.status === "done") {
      setTrailerImageLoading(false);
      const url = info.file.response.url + "/trailerImage";
      setTrailerImageUrl(url);
      episodesForm.setFieldsValue({
        trailerImage: url,
      });
    }
  };

  const handleLogoImageUploadStatusChange = (info) => {
    console.log("logo image upload - ", info);
    if (info.file.status === "uploading") {
      setLogoImageLoading(true);
      return;
    }

    if (info.file.status === "done") {
      setLogoImageLoading(false);
      const url = info.file.response.url + "/logoImage";
      setLogoImageUrl(url);
      episodesForm.setFieldsValue({
        logoImage: url,
      });
    }
  };

  return (
    <>
      {data && (
        <Card>
          <Form layout="vertical" form={episodesForm} scrollToFirstError={true}>
            <Row gutter={20}>
              <Col span={15}>
                <Row>
                  <Form.Item
                    name={"number"}
                    initialValue={episode_number + 1}
                    label={"Episode Number"}
                    rules={[
                      {
                        required: true,
                        validator: validateNumberField,
                      },
                    ]}
                  >
                    <Input placeholder="Enter Episode number" />
                  </Form.Item>
                </Row>
                <Row>
                  <Col span={15}>
                    <Form.Item
                      name={"title"}
                      label="Title"
                      rules={[
                        {
                          required: true,
                          validator: validateInputFields,
                        },
                      ]}
                      extra="English"
                    >
                      <Input
                        placeholder="Enter title here..."
                        maxLength={150}
                        showCount
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={30}>
              <Col span={15}>
                {Telugu && (
                  <Row gutter={30}>
                    <Col span={24}>
                      <Form.Item
                        name={"title_telugu"}
                        label="Spanish Title"
                        rules={[
                          {
                            required: true,
                            validator: validateInputFields,
                          },
                        ]}
                        extra="Spanish"
                      >
                        <Input
                          placeholder="Enter title here..."
                          maxLength={150}
                          showCount
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                )}
                {Hindi && (
                  <Row gutter={30}>
                    <Col span={24}>
                      <Form.Item
                        name={"title_hindi"}
                        label="German Title"
                        rules={[
                          {
                            required: true,
                            validator: validateInputFields,
                          },
                        ]}
                        extra="German"
                      >
                        <Input
                          placeholder="Enter title here..."
                          maxLength={150}
                          showCount
                        // value={movie.HindiTitle}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                )}
                {Tamil && (
                  <Row gutter={30}>
                    <Col span={24}>
                      <Form.Item
                        name={"title_tamil"}
                        label="French Title"
                        rules={[
                          {
                            required: true,
                            validator: validateInputFields,
                          },
                        ]}
                        extra="French"
                      >
                        <Input
                          placeholder="Enter title here..."
                          maxLength={150}
                          showCount
                        // value={movie.TamilTitle}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                )}
              </Col>
              <Col span={7}></Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name={"description"}
                  label="Synopsis (English)"
                  rules={[
                    {
                      required: true,
                      validator: validateDescriptionFields,
                    },
                  ]}
                >
                  <TextArea
                    placeholder="Enter description here..."
                    extra="English"
                    showCount
                    maxLength={500}
                    rows="4"
                  />
                </Form.Item>
              </Col>
            </Row>
            {Telugu && (
              <Row gutter={30}>
                <Col span={24}>
                  <Form.Item
                    name={"description_telugu"}
                    label="Synopsis (Spanish)"
                    rules={[
                      {
                        required: true,
                        validator: validateDescriptionFields,
                      },
                    ]}
                  >
                    <TextArea
                      rows={4}
                      placeholder="Enter short description of the series"
                      showCount
                      maxLength={500}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
            {Hindi && (
              <Row gutter={30}>
                <Col span={24}>
                  <Form.Item
                    name={"description_hindi"}
                    label="Synopsis (German)"
                    rules={[
                      {
                        required: true,
                        validator: validateDescriptionFields,
                      },
                    ]}
                  >
                    <TextArea
                      rows={4}
                      placeholder="Enter short description of the series"
                      showCount
                      maxLength={500}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
            {Tamil && (
              <Row gutter={30}>
                <Col span={24}>
                  <Form.Item
                    name={"description_tamil"}
                    label="Synopsis (French)"
                    rules={[
                      {
                        required: true,
                        validator: validateDescriptionFields,
                      },
                    ]}
                  >
                    <TextArea
                      rows={4}
                      placeholder="Enter short description of the series"
                      showCount
                      maxLength={500}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Form.Item
              name={"creator"}
              label={"Creator"}
              rules={[{ required: true }]}
            >
              <Select
                mode="single"
                placeholder="Select a creator"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
              >
                {creators &&
                  creators.map((c) => (
                    <Option key={c.name} value={c._id}>
                      {c.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Publish Date"
              rules={[{ required: true, message: "Publish Date required" }]}
            >
              <DatePicker
                value={releaseDate ? releaseDate : null}
                style={{ width: "30%" }}
                onChange={(_, datestring) => {
                  datestring
                    ? setReleaseDate(dayjs(datestring))
                    : setReleaseDate(null);
                }}
              />
            </Form.Item>
            <Divider />
            <Row gutter={30}>
              <Col span={24}>
                <Title level={4}>
                  Themes{" "}
                  <Tooltip title="Add themes for the season in Catalog Listing if the options are empty">
                    <span>
                      <InfoCircleOutlined />
                    </span>
                  </Tooltip>
                </Title>
              </Col>
            </Row>
            <Row>
              <Form.Item name={"genre"} noStyle rules={[{ required: false }]}>
                <Select
                  style={{ width: "50%" }}
                  mode="multiple"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                >
                  {genres &&
                    genres.map((g) => (
                      <Option key={g.name} value={g._id}>
                        {g.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Row>
            <Divider />
            <Row gutter={30}>
              <Col span={24}>
                <Title level={4}>
                  Cast & Crew{" "}
                  <Tooltip title="Add cast & crew for the season in Cast & Crew section if the options are empty">
                    <span>
                      <InfoCircleOutlined />
                    </span>
                  </Tooltip>
                </Title>
              </Col>
            </Row>
            <Col span={30}>
              <Form.Item
                name={"hosts"}
                label="Hosts"
                rules={[{ required: false }]}
              >
                <Select
                  style={{ width: "50%" }}
                  mode="multiple"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                >
                  {hosts &&
                    hosts.map((h) => (
                      <Option key={h.name} value={h._id}>
                        {h.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item
                name={"guests"}
                label="Guests"
                rules={[{ required: false }]}
              >
                <Select
                  style={{ width: "50%" }}
                  mode="multiple"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                >
                  {guests &&
                    guests.map((h) => (
                      <Option key={h.name} value={h._id}>
                        {h.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item
                name={"tech"}
                label="Technical Help"
                rules={[{ required: false }]}
              >
                <Select
                  style={{ width: "50%" }}
                  mode="multiple"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                >
                  {tech &&
                    tech.map((h) => (
                      <Option key={h.name} value={h._id}>
                        {h.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Divider />
            <Row>
              <Col>
                <Title level={5}>Graphic assets </Title>
                <Text>
                  Key art (also known as cover or the title art) represents your
                  title on Prime Video.{" "}
                  <strong>
                    Please include legible titles on your key art.
                  </strong>{" "}
                  The background image adds visual interests to video detail
                  pages.
                </Text>
              </Col>
            </Row>
            <Row>
              <div style={{ marginLeft: "10%", marginRight: "10%" }}>
                <Row
                  gutter={30}
                  style={{ marginTop: "20px" }}
                  justify={"center"}
                >
                  {/* 16:9 Image */}
                  <Col span="8">
                    <Row>
                      <Col span={24}>
                        <Text>
                          <strong>
                            <font color="red">*</font>Key art
                          </strong>{" "}
                          (16:9){" "}
                        </Text>
                      </Col>
                      <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                        <Form.Item
                          name={"detailImage"}
                          rules={[{ required: true }]}
                        >
                          <Upload
                            showUploadList={false}
                            action={`${apiUrl}/uploads/fastpixUploads`}
                            headers={{
                              authorization: `Bearer ${token}`,
                            }}
                            beforeUpload={beforeImageUpload}
                            onChange={handleDetailImageUploadStatusChange}
                          >
                            <Button size="small">Browse...</Button>
                          </Upload>
                        </Form.Item>{" "}
                      </Col>
                      <Col span={24}>
                        {detailImageUrl ? (
                          <Image
                            style={{
                              aspectRatio: "16/9",
                              objectFit: "contain",
                            }}
                            src={detailImageUrl}
                          />
                        ) : (
                          <Text type="warning" style={{ marginRight: "10px" }}>
                            <span>
                              <WarningFilled />
                            </span>{" "}
                            Click to Upload Image
                          </Text>
                        )}
                      </Col>
                    </Row>
                  </Col>
                  <Col span={8}> </Col>
                  {/* 3:4 Image */}
                  <Col span="8">
                    <Row>
                      <Col span={24}>
                        <Text>
                          <strong>Key art</strong> (3:4) (Optional){" "}
                        </Text>
                      </Col>
                      <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                        <Form.Item
                          name={"cardImage"}
                          rules={[{ required: false }]}
                        >
                          <Upload
                            showUploadList={false}
                            action={`${apiUrl}/uploads/fastpixUploads`}
                            headers={{
                              authorization: `Bearer ${token}`,
                            }}
                            beforeUpload={beforeImageUpload}
                            onChange={handleCardImageUploadStatusChange}
                          >
                            <Button size="small">Browse...</Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        {cardImageUrl ? (
                          <Image
                            style={{
                              aspectRatio: "16/9",
                              objectFit: "contain",
                            }}
                            src={cardImageUrl}
                          />
                        ) : (
                          <Text type="warning" style={{ marginRight: "10px" }}>
                            <span>
                              <WarningFilled />
                            </span>{" "}
                            Click to Upload Image
                          </Text>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Divider style={{ margin: "10px 2" }} />
                </Row>
                <Row
                  gutter={30}
                  style={{ marginTop: "20px" }}
                  justify={"center"}
                >
                  {/* Logo Image */}
                  <Col span="8">
                    <Row>
                      <Col span={24}>
                        <Text>
                          <strong>Logo Image (16:9)</strong> (Optional){" "}
                        </Text>
                      </Col>
                      <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                        <Form.Item
                          name={"logoImage"}
                          rules={[{ required: false }]}
                        >
                          <Upload
                            showUploadList={false}
                            action={`${apiUrl}/uploads/fastpixUploads`}
                            headers={{
                              authorization: `Bearer ${token}`,
                            }}
                            beforeUpload={beforeImageUpload}
                            onChange={handleLogoImageUploadStatusChange}
                          >
                            <Button size="small">Browse...</Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        {logoImageUrl ? (
                          <Image
                            style={{
                              aspectRatio: "16/9",
                              objectFit: "contain",
                            }}
                            src={logoImageUrl}
                          />
                        ) : (
                          <Text type="warning" style={{ marginRight: "10px" }}>
                            <span>
                              <WarningFilled />
                            </span>{" "}
                            Click to Upload Image
                          </Text>
                        )}
                      </Col>
                    </Row>
                  </Col>
                  <Col span={8}> </Col>
                  {/* Background Image */}
                  <Col span="8">
                    <Row>
                      <Col span={24}>
                        <Text>
                          <strong>Background Image (21:9)</strong> (Optional){" "}
                        </Text>
                      </Col>
                      <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                        <Form.Item
                          name={"trailerImage"}
                          rules={[{ required: false }]}
                        >
                          <Upload
                            showUploadList={false}
                            action={`${apiUrl}/uploads/fastpixUploads`}
                            headers={{
                              authorization: `Bearer ${token}`,
                            }}
                            beforeUpload={beforeImageUpload}
                            onChange={handleTrailerImageUploadStatusChange}
                          >
                            <Button size="small">Browse...</Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        {trailerImageUrl ? (
                          <Image
                            style={{
                              aspectRatio: "16/9",
                              objectFit: "contain",
                            }}
                            src={trailerImageUrl}
                          />
                        ) : (
                          <Text type="warning" style={{ marginRight: "10px" }}>
                            <span>
                              <WarningFilled />
                            </span>{" "}
                            Click to Upload Image
                          </Text>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Row>
            <Divider />
            <Row gutter={30}>
              <Col span={24}>
                {streamType === "default" && (
                  <Title level={4}>
                    Video and Audio Files{" "}
                    <span style={{ fontSize: "15px" }}></span>
                  </Title>
                )}
              </Col>
            </Row>
            {streamType === "default" && (
              <Form.Item name={"playbackUrl"}>
                <div style={{ width: "50%" }}>
                  <DirectUpload
                    content_id={episode_number}
                    duration={data?.duration}
                    content_type={"episode"}
                    content_title={data?.title ? data.title : "Episode Video"}
                    playbackUrl={data?.playbackUrl ? data.playbackUrl : null}
                    status={
                      data.playbackUrlStatus !== undefined
                        ? data.playbackUrlStatus === "ready"
                          ? "ready"
                          : "uploaded"
                        : ""
                    }
                    card_title={"Main Content"}
                    custom_image={data.thumbnail_content ? data.thumbnail_content : data?.detailImage}
                    download_url={data.mp4PlaybackUrl ? data.mp4PlaybackUrl : data?.detailImage}
                  />
                </div>
              </Form.Item>
            )}
            {streamType === "default" && (
              <Row gutter={30} style={{ width: "100%" }}>
                <Card
                  title="Embed Code"
                  style={{ width: "80%", marginLeft: "3px" }}
                  size="small"
                  extra={
                    <Tooltip title="Copy Code">
                      <Button
                        type="text"
                        onClick={() => {
                          navigator.clipboard.writeText(
                            `<div style="position: relative; aspect-ratio: 16/9;">\n  <iframe \n    src=https://tv.rocketlane.com/player/episode/${data._id} \n    loading="lazy" style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%;" \n    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"\n    allowfullscreen="true">\n  </iframe>\n</div>`
                          );
                          message.success("Copied Embed code");
                        }}
                      >
                        <CopyOutlined />
                      </Button>
                    </Tooltip>
                  }
                >
                  <Space direction="vertical">
                    <HtmlDisplay
                      htmlContent={`<div style="position: relative; aspect-ratio: 16/9;">\n  <iframe \n    src=https://tv.rocketlane.com/player/episode/${data._id} \n    loading="lazy" style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%;" \n    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"\n    allowfullscreen="true">\n  </iframe>\n</div>`}
                      style={{ width: "100%" }}
                    />
                  </Space>
                </Card>
              </Row>
            )}
            {streamType === "default" && (
              <Row gutter={30} style={{ marginTop: "20px" }}>
                <Col span={24}>
                  <Space>
                    Enable Auto Generated Transcripts{"  "}
                    <Switch
                      checked={checked}
                      onChange={setChecked}
                      style={{ marginLeft: "10px" }}
                    />
                    <Tooltip title="Enabling this will show auto-generated transcripts on the player, By default transcripts automatically generated are disabled">
                      <QuestionCircleOutlined
                        style={{
                          fontSize: "20px",
                          marginLeft: "5px",
                          marginTop: "5px",
                        }}
                      />
                    </Tooltip>
                  </Space>
                </Col>
              </Row>
            )}
            {streamType === "default" && (
              <Row gutter={30} style={{ marginTop: "30px" }}>
                <Col span={24}>
                  <Title level={4}>
                    Transcripts <span style={{ fontSize: "15px" }}></span>
                  </Title>
                </Col>
                <Col span={24}>
                  <Form.Item name={"subtitles"} noStyle>
                    {data && (
                      <UploadSubtitles
                        style={{ marginTop: "10px" }}
                        id={sessionStorage.getItem("content_id")}
                        upload={{
                          _id: `${episode_number}`,
                          type: "episode",
                          season: season,
                          episode: episode_number,
                        }}
                        subtitles={
                          data && "subtitles" in data ? data.subtitles : {}
                        }
                        updateContent={[data, setData]}
                        updateFlag={[subtitlesUploaded, setSubtitlesUploaded]}
                      />
                    )}
                    {(data && "subtitles" in data) ||
                      subtitlesUploaded ? null : (
                      <Col span={10} style={{ marginTop: "10px" }}></Col>
                    )}
                  </Form.Item>
                </Col>
                <Divider style={{ marginTop: "3%" }} />
              </Row>
            )}
            <Row gutter={30}>
              <Col span={24}>
                <Title level={4}>Also available on</Title>
              </Col>
            </Row>
            <Row>
              <Space direction="vertical">
                <Space direction="horizontal" align="baseline">
                  <img src="/images/apple-podcast.svg" height={25} width={25} />
                  <Form.Item
                    name={"apple_podcast"}
                    rules={[
                      {
                        required: false,
                        validator: validateApplePodcastInput,
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter apple podcast url"
                      style={{ width: "200%" }}
                    />
                  </Form.Item>
                </Space>
                <Space direction="horizontal" align="baseline">
                  <img src="/images/spotify-icon.svg" height={25} width={25} />
                  <Form.Item
                    name={"spotify"}
                    rules={[
                      {
                        required: false,
                        validator: validateSpotifyInput,
                      },
                    ]}
                  >
                    <Input
                      placeholder="Input spotify url"
                      style={{ width: "200%" }}
                    />
                  </Form.Item>
                </Space>
                <Space direction="horizontal" align="baseline">
                  <img src="/images/youtube-icon.svg" height={25} width={25} />
                  <Form.Item
                    name={"youtube"}
                    rules={[
                      {
                        required: false,
                        validator: validateYoutubeInput,
                      },
                    ]}
                  >
                    <Input
                      placeholder="Input youtube url"
                      style={{ width: "200%" }}
                    />
                  </Form.Item>
                </Space>
              </Space>
            </Row>
            <Divider />
            <Row justify="end">
              <Col>
                <Form.Item>
                  <Button
                    type="primary"
                    danger={true}
                    style={{ padding: "0 20px" }}
                    onClick={() => {
                      confirm({
                        title: "Are you sure you want to delete this episode?",
                        icon: <ExclamationCircleOutlined />,
                        okText: "Yes",
                        okType: "danger",
                        cancelText: "No",
                        onOk() {
                          handleEpisodeDelete();
                        },
                      });
                    }}
                  >
                    Delete
                  </Button>
                </Form.Item>
              </Col>
              <Col>
                <Form.Item style={{ marginLeft: "10px" }}>
                  <Button
                    type="primary"
                    style={{ padding: "0 20px" }}
                    onClick={handleEpisodeSave}
                  >
                    Save
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      )}
    </>
  );
};

export default Episode;
